export default {
	site_name: 'aceee',
};
